import PageLayout from "@/components/PageLayout";
import ArticleSchema from "@/components/ArticleSchema";

const TShirtsZomerseizoen = () => (
 <PageLayout
 title="T-shirts bedrukken voor het zomerseizoen"
 metaDescription="T-shirts bedrukken voor de zomer. Lichte, comfortabele shirts met uw ontwerp. Ideaal voor evenementen, bedrijven en teams. Magic Print Den Haag."
 >
 <ArticleSchema title="T-shirts bedrukken voor het zomerseizoen" description="T-shirts bedrukken voor de zomer." slug="/t-shirts-zomerseizoen" />
 <h1 className="text-3xl md:text-5xl font-bold mb-6">
 T-shirts bedrukken voor het zomerseizoen
 </h1>
 <p className="text-lg text-muted-foreground mb-8">
 De zomer is hét seizoen voor bedrukte T-shirts. Of het nu gaat om festivals, sportevenementen, bedrijfsuitjes of promotieacties – een bedrukt T-shirt is de perfecte manier om op te vallen.
 </p>

 <section className="mb-12">
 <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Waarom zomer-T-shirts bedrukken?</h2>
 <ul className="space-y-2 text-muted-foreground">
 <li> Lichte, comfortabele materialen voor warm weer</li>
 <li> Perfecte promotie voor buitenevenementen</li>
 <li> Teambuilding met een unieke look</li>
 <li> Beschikbaar in alle kleuren en maten</li>
 </ul>
 </section>

 <section className="mb-12">
 <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Bestel op tijd</h2>
 <p className="text-muted-foreground">
 Wacht niet te lang met bestellen voor het zomerseizoen. Neem tijdig contact op met Magic Print zodat wij uw bestelling op tijd kunnen leveren. Wij adviseren u graag over de beste materialen en druktechnieken voor zomerkleding.
 </p>
 </section>
 </PageLayout>
);

export default TShirtsZomerseizoen;
